module.exports = "<v-container class=\"attachment--container px-0 ml-2 mt-0 pt-2\" >\n    <h1 v-if=\"!coCategoriesLoader\" class=\"attachment--container__title ml-3\" >\n        {{ documentType.name }} ({{ documentType.totalDocuments }})\n    </h1>\n    <document-attachments></document-attachments>\n</v-container>\n";


//////////////////
// WEBPACK FOOTER
// ./src/containers/documents/document-attachment-list/template.html
// module id = 1LLz
// module chunks = 0